import i18n from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../../../../../common/components/fields/TextField';
import useStyles from './ContactFormFields.styles';
import PhoneField from '../../../../../../common/components/fields/PhoneField';
import { IconButton } from '../../../../../../common/components/buttons';
import { Icon } from '../../../../../../common/components/icons';

const ContactFormFields = ({ index, contactsLength, onDeleteClick }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <TextField name={`contacts.${index}.name`} label={i18n.t('mission.table.name')} classes={{ root: classes.textField }} />
      <PhoneField name={`contacts.${index}.phoneNumber`} label={i18n.t('mission.table.phone')} classes={{ root: classes.textField }} />
      <TextField name={`contacts.${index}.email`} label={i18n.t('mission.table.email')} classes={{ root: classes.textField }} />
      {index !== contactsLength - 1 && (
        <IconButton onClick={() => onDeleteClick(index)} className={classes.deleteButton}>
          <Icon icon="delete" />
        </IconButton>
      )}
    </div>
  );
};

ContactFormFields.propTypes = {
  index: PropTypes.number.isRequired,
  contactsLength: PropTypes.number.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
};

export default ContactFormFields;
